import {
  DELETE_USER_TENANT_REQUEST,
  DELETE_USER_TENANT_SUCCESS,
  DELETE_USER_TENANT_FAILURE,
  DELETE_USER_TENANT_RESET,
} from '../../../Constants/actionTypes';

const initial = {
  loading: false,
  success: false,
  result: null,
  error: '',
};

const deleteTenantReducer = (state = initial, action) => {
  switch (action.type) {
    case DELETE_USER_TENANT_REQUEST:
      return { ...state, loading: true, success: false, error: '' };

    case DELETE_USER_TENANT_SUCCESS:
      return { loading: false, success: true, result: action.payload, error: '' };

    case DELETE_USER_TENANT_FAILURE:
      return { loading: false, success: false, result: null, error: action.payload };

    case DELETE_USER_TENANT_RESET:
      return initial;

    default:
      return state;
  }
};

export default deleteTenantReducer;
